import React, { useEffect, useState } from "react";
import styled from "styled-components";
import "react-nice-dates/build/style.css";
import { Row, Col, Button, Card } from "reactstrap";
import CreateAPLPeriodModal from "../../components/Modal/CreateAPLPeriodModal";
import APLMoments from "../../components/APL/APLMoments";
import SupervisorInfoModal from "../../components/Modal/SupervisorInfoModal";
import APLDataGrid from "../../components/DataGrids/APLDataGrid";
import APLTabNavSelector from "../../components/Teacher/Tabs/APLTabNavSelector";
import APLRatings from "./APLRatings";
import APLDocumentsAndSupervisors from "./APLDocumentsAndSupervisors";
import {
  GetSupervisors,
  GetWorkCards,
  GetWorkCardHours,
  GetPeriods,
  GetEvents,
  GetEvaluations,
  GetEvaluationQuestions,
  GetTeacherInformation,
} from "../../actions/teacherQueries";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import { FormattedMessage } from "react-intl";
import {
  DeleteEvaluationQuestion,
  PostEvaluationQuestions,
  UpdateEvaluationQuestion,
  DeleteWorkstep,
  DeleteWorkstepComponent,
  EditWorkstepComponent,
  EditWorkStep,
} from "../../actions/teacherMutations";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import APLInformationPersonInfoModal from "../Modal/APLInformationPersonInfoModal";
import AddWorkStepModal from "../Modal/AddWorkStepModal";
import AddNewWorkStepComponentModal from "../Modal/AddNewWorkStepComponentModal";
import RemoveAndChangeDateApl from "./RemoveAndChangeDateApl";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ConfirmDialog from "../Modal/ConfirmDialog";
import { injectIntl } from "react-intl";
import { useQueryClient } from "react-query";
import EditNameDialog from "../Modal/EditNameDialogModal";
import APLPresence from "./APLPresence";

const APL = ({ level, students, objId, schoolId, intl, programId }) => {
  //Modals
  const [supervisorInfoOpen, setSupervisorInfo] = useState(false);
  const toggleSupervisorInfo = () => setSupervisorInfo(!supervisorInfoOpen);
  const [aplPeriodOpen, setAplPeriodOpen] = useState(false);
  const toggleCreatePeriod = () => setAplPeriodOpen(!aplPeriodOpen);
  const [infoPersonOpen, setInfoPersonOpen] = useState(false);
  const toggleInfoPersonOpen = () => setInfoPersonOpen(!infoPersonOpen);
  const [addNewWorkStepOpen, setAddNewWorkStepOpen] = useState(false);
  const toggleAddNewWorkStepModal = () =>
    setAddNewWorkStepOpen(!addNewWorkStepOpen);
  const [addNewWorkStepComponentOpen, setAddNewWorkStepComponentOpen] =
    useState(false);
  const [currentWorkStepForAddComponent, setCurrentWorkStepForAddComponent] =
    useState(null);

  const toggleAddNewWorkStepComponentModal = () => {
    setAddNewWorkStepComponentOpen(!addNewWorkStepComponentOpen);
  };

  //Objects
  const [supervisor, setSupervisor] = useState(null);
  const [period, setPeriod] = useState(null);
  const [activePeriodId, setActivePeriodId] = useState(null);
  const [periodsToSelect, setPeriodsToSelect] = useState([]);
  const [studentRatings, setStudentRatings] = useState(null);
  const [supervisorRatings, setSupervisorRatings] = useState(null);
  const [studentQuestions, setStudentQuestions] = useState([]);
  const [supervisorQuestions, setSupervisorQuestions] = useState([]);
  const [questionsToDelete, setQuestionsToDelete] = useState([]);
  const [studentParticipation, setStudentParticipation] = useState(null);
  const [aplInfoPerson, setAplInfoPerson] = useState(null);
  const [currentPeriods, setCurrentPeriods] = useState(null);
  const [promtWorkComponentForDelete, setPromptComponentForDelete] =
    useState(null);
  const [workcardItemForEditName, setWorkcardItemForEditName] = useState(null);
  const [totalWorkHoursRegistered, setTotalWorkHoursRegistered] = useState(0);

  //Navigation
  const [aplActiveTab, setAPLActiveTab] = useState(
    activePeriodId !== 0 ? 1 : 2
  );
  const [ratingLevel, setRatingLevel] = useState("student");
  const [levelSupervisor, setLevelSupervisor] = useState("supervisor");
  //Mutations
  const createEvaluationQuestions = useMutation(PostEvaluationQuestions);
  const updateEvaluationQuestion = useMutation(UpdateEvaluationQuestion);
  const deleteEvaluationQuestions = useMutation(DeleteEvaluationQuestion);
  const deleteWorkstep = useMutation(DeleteWorkstep);
  const deleteWorkstepComponent = useMutation(DeleteWorkstepComponent);
  const editWorkStep = useMutation(EditWorkStep);
  const editWorkStepComponent = useMutation(EditWorkstepComponent);

  const periodsData = GetPeriods(level, objId);
  const eventsData = GetEvents(level, activePeriodId, objId);
  const workCardHourData = GetWorkCardHours(level, activePeriodId, objId);
  const evaluationsData = GetEvaluations(activePeriodId);
  const evaluationQuestionsData = GetEvaluationQuestions(activePeriodId);
  const teacherInfo = GetTeacherInformation();
  const navReducer = useSelector((state) => state.teacherTabNavReducer);
  const queryClient = useQueryClient();

  const handleDeleteItem = () => {
    if (promtWorkComponentForDelete.isWorkstep) {
      deleteWorkstep.mutate(promtWorkComponentForDelete.id, {
        throwOnError: true,
        onError: (data) => {
          toast.warn(data.response.data);
        },
        onSuccess: (data) => {
          if (data?.status > 199 && data.status < 300) {
            toast.success(
              intl.formatMessage(
                { id: "WorkstepNameDeleted" },
                {
                  name: promtWorkComponentForDelete.name,
                }
              )
            );
            queryClient.invalidateQueries([
              "FetchWorkCardHours",
              [level, activePeriodId, objId],
            ]);
          } else {
            toast.warn(intl.formatMessage({ id: data.trim() }));
          }
        },
      });
    } else if (!promtWorkComponentForDelete.isWorkstep) {
      deleteWorkstepComponent.mutate(promtWorkComponentForDelete.id, {
        throwOnError: true,
        onSuccess: (data) => {
          if (data?.status > 199 && data.status < 300) {
            queryClient.invalidateQueries([
              "FetchWorkCardHours",
              [level, activePeriodId, objId],
            ]);
            toast.success(
              intl.formatMessage(
                { id: "WorkstepComponentNameDeleted" },
                {
                  name: promtWorkComponentForDelete.name,
                }
              )
            );
            setWorkcardItemForEditName(null);
          } else {
            toast.warn(intl.formatMessage({ id: data.trim() }));
          }
        },
        onError: (data) => {
          toast.warn(data.response.data);
        },
      });
    }
    setPromptComponentForDelete(null);
  };

  const handleChangeNameOnWorkcardItem = () => {
    if (workcardItemForEditName.isWorkstep) {
      editWorkStep.mutate(workcardItemForEditName, {
        throwOnError: true,
        onError: (data) => {
          toast.warn(data.response.data);
        },
        onSuccess: (data) => {
          if (data?.status > 199 && data.status < 300) {
            toast.success(
              intl.formatMessage(
                { id: "WorkstepNameChangedTo" },
                {
                  name: workcardItemForEditName.name,
                }
              )
            );
            queryClient.invalidateQueries([
              "FetchWorkCardHours",
              [level, activePeriodId, objId],
            ]);
            setWorkcardItemForEditName(null);
          } else {
            toast.warn(intl.formatMessage({ id: data.trim() }));
            setWorkcardItemForEditName(null);
          }
        },
      });
    } else if (!workcardItemForEditName.isWorkstep) {
      editWorkStepComponent.mutate(workcardItemForEditName, {
        throwOnError: true,
        onSuccess: (data) => {
          if (data?.status > 199 && data.status < 300) {
            queryClient.invalidateQueries([
              "FetchWorkCardHours",
              [level, activePeriodId, objId],
            ]);
            toast.success(
              intl.formatMessage(
                { id: "WorkstepComponentNameChangedTo" },
                {
                  name: workcardItemForEditName.name,
                }
              )
            );
            setWorkcardItemForEditName(null);
          } else {
            toast.warn(intl.formatMessage({ id: data.trim() }));
            setWorkcardItemForEditName(null);
          }
        },
        onError: (data) => {
          toast.warn(data.response.data);
        },
      });
    }
    setPromptComponentForDelete(null);
  };

  /****USEEFFECTS*****/
  useEffect(() => {
    if (
      !periodsData.isLoading &&
      periodsData.data &&
      periodsData.data.some(
        (prd) => prd.period.id === navReducer.selectedAplPeriodId
      )
    ) {
      const tempPeriod = periodsData.data.find(
        (prd) => prd.period.id === navReducer.selectedAplPeriodId
      );

      if (level === "Student") {
        tempPeriod.period.students = tempPeriod.period.students.filter(
          (studentObj) => {
            return studentObj.student.id === objId;
          }
        );
      }
      tempPeriod.period.students.sort((a, b) => {
        let nameA = a.student.name.toUpperCase();
        let nameB = b.student.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });

      setPeriod(tempPeriod);
      setActivePeriodId(navReducer.selectedAplPeriodId);
      setAPLActiveTab(navReducer.selectedAplTab);
    }
  }, [
    navReducer.selectedAplPeriodId,
    navReducer.selectedAplTab,
    periodsData.isLoading,
    periodsData.data,
    objId,
    level,
  ]);

  useEffect(() => {
    if (!periodsData.isLoading) {
      setCurrentPeriods(periodsData.data);
    }
  }, [periodsData.data, periodsData.isLoading]);

  useEffect(() => {
    if (!workCardHourData.isLoading && workCardHourData.data !== null) {
      const handleSetWorkStepAndToggleComponentModal = (workstepId) => {
        setCurrentWorkStepForAddComponent(workstepId);
        setAddNewWorkStepComponentOpen(true);
      };
      let tableData = [];
      let totalWorkHours = 0;
      workCardHourData.data.forEach((wsi) => {
        if (wsi.isComponent) {
          totalWorkHours += wsi.hours;
        }
        const itemToAdd = wsi;
        wsi.edit = (
          <>
            <Button
              color="danger"
              outline={true}
              size="sm"
              onClick={() =>
                setPromptComponentForDelete({
                  id: wsi.id,
                  name: wsi.name,
                  isWorkstep: wsi.parentId === null,
                  hours: wsi.hours,
                  parentId: wsi.parentId,
                })
              }
            >
              <FontAwesomeIcon icon="trash" />
            </Button>
            <Button
              className="ms-2"
              color="primary"
              outline={true}
              size="sm"
              onClick={() =>
                setWorkcardItemForEditName({
                  id: wsi.id,
                  name: wsi.name,
                  isWorkstep: wsi.parentId === null,
                  parentId: wsi.parentId,
                })
              }
            >
              <FontAwesomeIcon icon="edit" />
            </Button>
          </>
        );
        tableData.push(itemToAdd);
      });
      const tempWorkSteps = tableData.filter((item) => item.parentId === null);
      tempWorkSteps.forEach((ws) => {
        tableData.push({
          parentId: ws.id,
          name: (
            <Button
              outline
              color="primary"
              onClick={() => handleSetWorkStepAndToggleComponentModal(ws.id)}
            >
              <FormattedMessage id="AddWorkStepComponent" />
            </Button>
          ),
          hours: null,
        });
      });
      tableData = tableData.sort((a, b) => {
        if (a === null) {
          return 1;
        }
        if (b === null) {
          return -1;
        }
        return a.hours < b.hours ? 1 : -1;
      });
      setTotalWorkHoursRegistered(totalWorkHours);
      setStudentParticipation(
        tableData.sort((a, b) => {
          return a.hours < b.hours ? 1 : -1;
        })
      );
    }
  }, [workCardHourData.data, workCardHourData.isLoading]);

  useEffect(() => {
    if (!evaluationsData.isLoading && evaluationsData.data !== null) {
      var studentEvaluations = [];
      var supervisorEvaluations = [];
      evaluationsData.data.forEach((question) => {
        switch (question.question.forUserType) {
          case 4:
            supervisorEvaluations.push(question);
            break;
          case 1:
            studentEvaluations.push(question);
            break;
          default:
            return null;
        }
      });
      setStudentRatings(studentEvaluations);
      setSupervisorRatings(supervisorEvaluations);
    }
  }, [evaluationsData.isLoading, evaluationsData.data]);

  useEffect(() => {
    if (
      !evaluationQuestionsData.isLoading &&
      evaluationQuestionsData.data !== null
    ) {
      var tempStudentQuestions = [];
      var tempSupervisorQuestions = [];

      evaluationQuestionsData.data.forEach((question) => {
        switch (question.forUserType) {
          case 4:
            tempSupervisorQuestions.push(question);
            break;
          case 1:
            tempStudentQuestions.push(question);
            break;
          default:
            return null;
        }
      });

      setStudentQuestions(tempStudentQuestions);
      setSupervisorQuestions(tempSupervisorQuestions);
    }
  }, [evaluationQuestionsData.isLoading, evaluationQuestionsData.data]);

  useEffect(() => {
    if (!periodsData.isLoading) {
      const tempSelectablePeriods = [];
      const tempPeriods = [];
      if (periodsData.data) {
        periodsData.data.forEach((period) => {
          tempPeriods.push(period);
          const dateFrom = new Date(period.period.from);
          const dateTo = new Date(period.period.to);
          const p = {
            value: period.period.id,
            label:
              period.period.name +
              (period.period.id !== 0
                ? " - " +
                  dateFrom.toLocaleDateString("sv") +
                  " till " +
                  dateTo.toLocaleDateString("sv")
                : ""),
          };
          tempSelectablePeriods.push(p);
        });

        setPeriodsToSelect(tempSelectablePeriods);
      }
      if (period) {
        if (
          !tempSelectablePeriods.find((p) => p.value === period?.period?.id)
        ) {
          setPeriod(null);
        }
      }
    }
  }, [periodsData.data, periodsData.isLoading, period]);

  /****END USEEFFECTS*****/

  //Handlers
  const handleSaveEvaluationQuestions = (periodId, studentQs, supervisorQs) => {
    var newQuestions = [];
    var questionsToUpdate = [];

    studentQs.forEach((q, index) => {
      var question = {
        periodId: periodId,
        question: q.question,
        responseRange: q.responseRange,
        sortOrder: index + 1,
        forUserType: "Student",
      };
      if (q.id) {
        questionsToUpdate.push({
          id: q.id,
          question: question,
        });
      } else {
        newQuestions.push(question);
      }
    });

    var tempQuestion = studentQs.filter((question) => question.id);
    setStudentQuestions(tempQuestion);

    supervisorQs.forEach((q, index) => {
      var question = {
        periodId: periodId,
        question: q.question,
        responseRange: q.responseRange,
        sortOrder: index + 1,
        forUserType: "AplSupervisor",
      };
      if (q.id) {
        questionsToUpdate.push({
          id: q.id,
          question: question,
        });
      } else {
        newQuestions.push(question);
      }
    });

    createEvaluationQuestions.mutate(newQuestions, {
      onSuccess: (data) => {
        var tempStudentQuestions = [...studentQs];
        var tempSupervisorQuestions = [...supervisorQs];
        data.forEach((question) => {
          switch (question.forUserType) {
            case 4:
              tempSupervisorQuestions.push(question);
              break;
            case 1:
              tempStudentQuestions.push(question);
              break;
            default:
              return null;
          }
        });

        var tempQuestion = tempStudentQuestions.filter(
          (question) => question.id
        );
        setStudentQuestions(tempQuestion);

        tempQuestion = tempSupervisorQuestions.filter(
          (question) => question.id
        );
        setSupervisorQuestions(tempQuestion);
      },
      throwOnError: true,
      onError: (data) => {
        toast.warn(data.response.data);
      },
    });

    questionsToUpdate.forEach((question) => {
      updateEvaluationQuestion.mutate(question, {
        throwOnError: true,
        onError: (data) => {
          toast.warn(data.response.data);
        },
      });
    });

    questionsToDelete.forEach((question) => {
      deleteEvaluationQuestions.mutate(question.id, {
        throwOnError: true,
        onError: (data) => {
          toast.warn(data.response.data);
        },
      });
    });

    if (questionsToDelete.length > 0) {
      var ratingQuestions = [...questionsToDelete];
      ratingQuestions.splice(0, ratingQuestions.length);
      setQuestionsToDelete(ratingQuestions);
    }
  };

  const handleSetWorkcardItemForEditName = (val) => {
    setWorkcardItemForEditName({ ...workcardItemForEditName, name: val });
  };

  const supervisors = GetSupervisors(schoolId);
  const workCards = GetWorkCards();

  if (
    supervisors.isLoading ||
    workCards.isLoading ||
    !currentPeriods ||
    eventsData.isLoading ||
    teacherInfo.isLoading
  ) {
    return <Pacmanloader />;
  }
  const programTeachers = [];
  teacherInfo.data.programmes
    .find((program) => program.id === Number(programId))
    .classes.forEach((cl) => {
      cl.teachers.forEach((teacher) => {
        if (!programTeachers.some((t) => t.id === teacher.id)) {
          programTeachers.push(teacher);
        }
      });
    });

  const columnExtensions = [
    { columnName: "hours", width: 350 },
    { columnName: "name", width: 350 },
    { columnName: "edit", width: 100 },
  ];

  const columns = [
    { title: "Namn", name: "name" },
    { title: "Antal timmar elever registrerat", name: "hours" },
    { title: "Redigera", name: "edit" },
  ];

  const mainPanelContent = (tabIndex) => {
    switch (tabIndex) {
      case 1:
        return (
          <Col lg={12}>
            <Card body>
              <APLPresence
                students={period.period.students.filter((st) =>
                  students.some(
                    (studentInLevel) => studentInLevel.id === st.student.id
                  )
                )}
                objId={objId}
                level={level}
                activePeriodId={activePeriodId}
                periodStart={period.period.from}
                periodEnd={period.period.to}
              />
            </Card>
          </Col>
        );
      case 2:
        return (
          <div>
            {studentParticipation ? (
              <>
                <HeaderRowNoScroll className="pt-2 ps-4 pb-2">
                  <Col>
                    <h5 style={{ fontWeight: "lighter", margin: "0" }}>
                      <FormattedMessage id="NumberOfHoursRegisteredPerWorkstep" />{" "}
                      - {period.period.workCard.name}
                    </h5>
                  </Col>
                </HeaderRowNoScroll>
                <APLDataGrid
                  period={period.period}
                  data={studentParticipation}
                  columns={columns}
                  columnExtensions={columnExtensions}
                  showDelete={true}
                />
                <Row className="p-3">
                  <Col>
                    <h5 className="lead">
                      <FormattedMessage id="TotalAmountOfHours" />:{" "}
                      {totalWorkHoursRegistered}
                    </h5>
                  </Col>
                </Row>
                <ConfirmDialog
                  isOpen={promtWorkComponentForDelete !== null}
                  toggle={() => setPromptComponentForDelete(null)}
                  title={intl.formatMessage({ id: "AreYouSure" })}
                  message={intl.formatMessage(
                    { id: "IfYouDeleteWorkstepNoRegistrationsCanBeMade" },
                    {
                      name:
                        promtWorkComponentForDelete !== null
                          ? promtWorkComponentForDelete.name
                          : "",
                    }
                  )}
                  onProceed={() => handleDeleteItem()}
                  danger={true}
                />
                <EditNameDialog
                  toggle={() => setWorkcardItemForEditName(null)}
                  isOpen={workcardItemForEditName !== null}
                  title={"Byt namn"}
                  defaultName={workcardItemForEditName?.name}
                  onChange={(val) => handleSetWorkcardItemForEditName(val)}
                  onProceed={() => handleChangeNameOnWorkcardItem()}
                />
              </>
            ) : (
              <div>
                <FormattedMessage id="NothingToShow" />
              </div>
            )}
            <Button
              outline
              className="m-2"
              color="primary"
              onClick={() => toggleAddNewWorkStepModal()}
            >
              <FormattedMessage id="AddWorkStep" />
            </Button>
            <AddWorkStepModal
              workCardId={period.period.workCard.id}
              isOpen={addNewWorkStepOpen}
              toggle={toggleAddNewWorkStepModal}
              level={level}
              objId={objId}
            />
            <AddNewWorkStepComponentModal
              workStepId={currentWorkStepForAddComponent}
              workCardId={period.period.workCard.id}
              isOpen={addNewWorkStepComponentOpen}
              toggle={toggleAddNewWorkStepComponentModal}
              level={level}
              objId={objId}
            />
          </div>
        );
      case 3:
        return (
          <ColWithoutScroll
            lg={8}
            className="d-sm-flex d-lg-flex"
            style={{ margin: "auto" }}
          >
            <APLMoments
              period={period.period}
              studentEvents={eventsData}
              students={students}
              level={level}
              periodId={period.period.id}
              objectId={objId}
            />
          </ColWithoutScroll>
        );
      case 4:
        return (
          <>
            <RemoveAndChangeDateApl
              currentStartDate={period.period.from}
              currentEndDate={period.period.to}
              periodId={period.period.id}
              periodName={period.period.name}
              level={level}
              objId={objId}
              setPeriod={setPeriod}
            />
            {students.length > 0 && (
              <APLDocumentsAndSupervisors
                allSupervisors={supervisors.data}
                setLevelSupervisor={setLevelSupervisor}
                levelSupervisor={levelSupervisor}
                setSupervisor={setSupervisor}
                toggleSupervisorInfo={toggleSupervisorInfo}
                period={period}
                setPeriod={setPeriod}
                toggleInfoPersonOpen={toggleInfoPersonOpen}
                setAplInfoPerson={setAplInfoPerson}
                level={level}
                objId={objId}
                students={students}
                schoolId={schoolId}
                programTeachers={programTeachers}
                programId={programId}
              />
            )}
            {studentRatings && supervisorRatings && (
              <APLRatings
                loading={evaluationQuestionsData.isLoading}
                ratingLevel={ratingLevel}
                setRatingLevel={setRatingLevel}
                studentRatings={studentRatings}
                supervisorRatings={supervisorRatings}
                setStudentRatings={setStudentRatings}
                setSupervisorRatings={setSupervisorRatings}
                handleSaveEvaluationQuestions={handleSaveEvaluationQuestions}
                activePeriodId={activePeriodId}
                studentQuestions={studentQuestions}
                setStudentQuestions={setStudentQuestions}
                supervisorQuestions={supervisorQuestions}
                setSupervisorQuestions={setSupervisorQuestions}
                questionsToDelete={questionsToDelete}
                setQuestionsToDelete={setQuestionsToDelete}
                level={level}
                objId={objId}
                students={students}
              />
            )}
          </>
        );
      default:
        return;
    }
  };

  return (
    <div className="apl--container">
      <APLTabNavSelector
        setAPLActiveTab={setAPLActiveTab}
        activeTab={aplActiveTab}
        toggleCreatePeriod={toggleCreatePeriod}
        periodsToSelect={periodsToSelect}
        period={period}
      />
      <DivNoScroll className="pt-3">
        <HeaderRowNoScroll>
          {period && (
            <ColWithoutScroll
              lg={12}
              sm={12}
              style={{ minHeight: "63vh", overflow: "auto" }}
            >
              <HeaderRowNoScroll className="pt-2">
                <ColWithoutScroll lg={12}>
                  {mainPanelContent(aplActiveTab)}
                </ColWithoutScroll>
              </HeaderRowNoScroll>
            </ColWithoutScroll>
          )}
        </HeaderRowNoScroll>
        <CreateAPLPeriodModal
          students={students}
          isOpen={aplPeriodOpen}
          toggle={toggleCreatePeriod}
          supervisors={supervisors.data}
          existingWorkCards={workCards.data}
          currentPeriods={currentPeriods}
          setCurrentPeriods={setCurrentPeriods}
          handleSaveEvaluationQuestions={handleSaveEvaluationQuestions}
          studentQuestions={studentQuestions}
          setStudentQuestions={setStudentQuestions}
          supervisorQuestions={supervisorQuestions}
          setSupervisorQuestions={setSupervisorQuestions}
          questionsToDelete={questionsToDelete}
          setQuestionsToDelete={setQuestionsToDelete}
          schoolId={schoolId}
          level={level}
          objId={objId}
          programTeachers={programTeachers}
        />
        {supervisor && (
          <SupervisorInfoModal
            isOpen={supervisorInfoOpen}
            toggle={toggleSupervisorInfo}
            supervisor={supervisor}
          />
        )}
        {aplInfoPerson && (
          <APLInformationPersonInfoModal
            aplInfoPerson={aplInfoPerson}
            toggleInfoPersonOpen={toggleInfoPersonOpen}
            infoPersonOpen={infoPersonOpen}
          />
        )}
      </DivNoScroll>
    </div>
  );
};
export default injectIntl(APL);

const ColWithoutScroll = styled(Col)``;

const DivNoScroll = styled.div`
  &::-webkit-scrollbar {
    display: none;
  }
`;

const HeaderRowNoScroll = styled(Row)`
  &::-webkit-scrollbar {
    display: none;
  }
`;
